import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-yoga-pr',
	options: {
		userTags: ['tai_chi_yoga'],
	},
	landing: {
		ids: ['loader-tai-chi-yoga-m', 'age-tai-chi-yoga-m-pr'],
		route: {
			path: '/tai-chi-yoga-m-pr',
			name: 'tai-chi-yoga-m-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-yoga',
		route: {
			path: '/tai-chi-yoga-m-pr/ob/:page*',
			name: 'activity-male-tai-chi-yoga-pr',
		},
		slug: 'activity-male-tai-chi-yoga-pr',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-yoga-m-pr',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-yoga-m'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
